import createMessageWithAttachmentAction from '../actions/createMessageWithAttachmentAction';
import createCloudFileFromAttachmentData from '../utils/createCloudFileFromAttachmentData';
import replyToMessageAndCreateViewStateWithSmartDocOption from '../utils/replyToMessageAndCreateViewStateWithSmartDocOption';
import { CloudFile } from 'owa-attachment-file-types';
import { ComposeViewState } from 'owa-mail-compose-store';
import { ClientItem } from 'owa-mail-store';
import * as trace from 'owa-trace';
import { orchestrator } from 'satcheljs';
import { lazyCreateAttachments } from 'owa-mail-compose-actions';
import { SmartDocOption } from 'owa-mail-smart-pill-features';
import { logUsage } from 'owa-analytics';

export default orchestrator(
    createMessageWithAttachmentAction,
    async function createMessageWithAttachmentOrchestrator(actionMessage) {
        const { item, attachment, option } = actionMessage;

        if (!attachment) {
            // If has no attachments, open the compose form and the corresponding file picker.
            await replyToMessageAndCreateViewStateWithSmartDocOption(item, option);
        } else {
            // If has an attachment, upload the file and open the compose form with an attachment.
            try {
                await createCloudFileFromAttachmentData(attachment, async cloudFile => {
                    onCloudFileReady(item, cloudFile, option);
                });
            } catch (e) {
                trace.errorThatWillCauseAlert(
                    `[createMessageWithAttachmentOrchestrator] Error when creating cloud file: ${e.message}`
                );
            }
        }
    }
);

export async function onCloudFileReady(
    item: ClientItem,
    cloudFile: CloudFile,
    option: SmartDocOption
): Promise<void> {
    if (cloudFile) {
        const viewState = await replyToMessageAndCreateViewStateWithSmartDocOption(item, option);

        const createAttachments = await lazyCreateAttachments.import();
        // Find the existing compose view state or create a new one if necessary.

        createAttachments(
            [cloudFile] /* files */,
            viewState,
            {
                isInline: false,
                isHiddenInline: false,
                shouldShare: true,
                isAddedFromSmartDoc: true,
            },
            () => logSmartDocAttachmentsAdded(item, viewState) /* onAllAttachmentsProcessed */,
            null /* onAttachmentCreatedCallback */,
            null /* onAttachmentCanceledOrFailedCallback */,
            null /* tryAgainCallback */
        );
    }
}

async function logSmartDocAttachmentsAdded(
    item: ClientItem,
    viewState: ComposeViewState
): Promise<void> {
    logUsage(
        'SmartDocAttachmentsAdded',
        { smartDocExtractionId: item.SmartDocData.EntityId },
        { isCore: true, isCosmosDatapoint: true }
    );

    // Reset the SmartDocOption as user may add more attachments in the compose form, which should
    // be logged as "not fromSmartDoc".
    viewState.smartPillViewState.smartDocOption = SmartDocOption.None;
}
